import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Gauge, Presentation, PencilRuler, Megaphone, Globe, Smile, Newspaper, FileText, MessageCircle, Settings } from 'lucide-react';
import CountUp from 'react-countup';
import './AboutUs.css';
import { useInView } from 'react-intersection-observer';
import aboutHeroImg from '../../assets/AboutUsPictures/aboutUsImg1.jpg';

const AboutUs = () => {

    const offers = [
    {
      title: "New Career Postings",
      text: "We're always updating our list of positions. Not only that, our applicants receive alerts on related opportunities.",
      icon: <Gauge size={40} strokeWidth={1.5} />
    },
    {
      title: "Higher Employment",
      text: "INFINITI helps employ more than our local competitors. How? Through creating a fluent and easy process for applicants to use.",
      icon: <Presentation size={40} strokeWidth={1.5} />
    },
    {
      title: "Applicant Profiles",
      text: "All applicants on our website can create an account and save all recent information. This helps for you to find the perfect applicant later or better yet, today!",
      icon: <PencilRuler size={40} strokeWidth={1.5} />
    },
    {
      title: "Promotion",
      text: "Our marketing team will make sure more eyeballs see your employee needs. Worry-less and hire more!",
      icon: <Megaphone size={40} strokeWidth={1.5} />
    },
    {
      title: "More Jobs",
      text: "Applicants will find more jobs on INFINITI than any other Central Florida website. You're probably thinking, 'WOW', but we just think it's right.",
      icon: <Globe size={40} strokeWidth={1.5} />
    },
    {
      title: "For Agencies",
      text: "We find that our applicants are overall happy with their placements. While nothing is perfect, we strive to make sure both parties expect and receive excellence.",
      icon: <Smile size={40} strokeWidth={1.5} />
    }
  ];

  const { ref, inView } = useInView({
    triggerOnce: true, 
    threshold: 0.3,
  });

  const stats = [
    {
      number: 7800,
      label: "Applications",
      text: "...and that number grows each day. For 2018, is to create even more opportunities for each of those applicants. More job postings and more email notifications.",
      icon: <Newspaper size={40} />
    },
    {
      number: 3400,
      label: "Careers Posted",
      text: "We've worked with a tremendous amount of businesses in Central Florida and from that, we've listed quite a bit of jobs! Did you find yours?",
      icon: <FileText size={40} />
    },
    {
      number: 1748,
      label: "Walk-Ins",
      text: "We only recently started counting but come to our office any day of the week and you'll be amazed by the amount of applicants that come by. Most with huge smiles.",
      icon: <MessageCircle size={40} />
    },
    {
      number: 342,
      label: "Company Partners",
      text: "We're partnered with more Central Florida businesses to make sure opportunities are flowing. We're always reaching out (and getting contacted!) about working together.",
      icon: <Settings size={40} />
    }
  ];

  return (
    <div className="about-us-page">
      
      {/* Section 1 ------------------------------------------------------------------ */}
      <section 
        className="about-hero-section" 
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)), url(${aboutHeroImg})` }}
      >
        <Container className="h-100 d-flex align-items-center justify-content-center">
          <div className="about-hero-content text-center text-white">
            
            <h1 className="about-title mb-3">About Us</h1>
            
            <p className="about-subtitle">
              We're a group of truly talented employment professionals.
            </p>

            <div className="about-divider mx-auto mb-3"></div>

          </div>
        </Container>
      </section>

      {/* Section 1 ------------------------------------------------------------------ */}

      {/* Section 2 ------------------------------------------------------------------ */}

      <section className="offers-section py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="offer-main-title">What do we offer?</h2>
            <p className="offer-main-subtitle mx-auto">
              We work closely with employers to insure that quality applicants are received promptly and steadily.
            </p>
          </div>

          <Row className="g-4">
            {offers.map((item, index) => (
              <Col lg={4} md={6} key={index}>
                <div className="offer-card">
                  <div className="offer-icon-wrapper">
                    {item.icon}
                  </div>
                  <h4 className="offer-card-title">{item.title}</h4>
                  <p className="offer-card-text">{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Section 2 ------------------------------------------------------------------ */}

      {/* Section 3 ------------------------------------------------------------------ */}

      <section className="stats-section py-5" ref={ref}>
        <Container>
          <Row className="g-4">
            {stats.map((stat, index) => (
              <Col lg={3} md={6} key={index}>
                <div className="stat-item text-center">
                  <div className="stat-icon-circle mx-auto mb-3">
                    {stat.icon}
                  </div>
                  
                  <div className="stat-number">
                    {inView ? (
                      <CountUp end={stat.number} duration={3} separator="," />
                    ) : (
                      "0"
                    )}
                    {stat.label === "Applications" && "+"}
                  </div>
                  
                  <h4 className="stat-label mb-3">{stat.label}</h4>
                  <p className="stat-description">{stat.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      {/* Section 3 ------------------------------------------------------------------ */}

      {/* Section 4 ------------------------------------------------------------------ */}
      <section className="about-detailed-section py-5">
        <Container>
            <Row className="justify-content-center">
            <Col lg={8} md={10}>
                <div className="detailed-story-wrapper py-4">
                
                <h2 className="detailed-title mb-4">About INFINITI Employment Solutions</h2>
                
                <div className="detailed-text-content">
                    <p className="lead-paragraph mb-4">
                    INFINITI Employment Solutions is a full service employment firm established in 1999. 
                    Without making you feel like we've discovered the cure for insomnia...here's a brief overview of our firm.
                    </p>

                    <p>
                    We're a group of truly talented employment professionals. We all share a total 
                    "Commitment to Quality" and a consistent dedication to being the BEST employment firm in Orlando! 
                    We're definitely Type "A" personalities.
                    </p>

                    <p>
                    We're the kind of people who take the ball and run with it. We believe if our people are challenged 
                    and comfortable with their environment, they exert a force and desire to solve problems that 
                    reach far beyond the limits of 9 to 5. We're problem solvers, not order fillers.
                    </p>

                    <p>
                    By thinking strategically, thinking creatively, and never relying on "one-size-fits-all" services, 
                    we have become exceptionally successful at creating innovative employment solutions that deliver 
                    bottomline results for our clients. In the end, our company is really about one thing:
                    </p>

                    {/* FOKUSIRANI TEKST */}
                    <div className="people-shoutout my-5 text-center">
                        PEOPLE... PEOPLE... PEOPLE...
                    </div>

                    <p>
                    .. So have we piqued your interest? This is where we are supposed to invite you to call us 
                    in an aloof fashion. But that's not our style. We're a little more down to earth. 
                    We'd love to work with you.
                    </p>

                    <p className="final-call">
                    We'd love to meet with you. But now, we'll leave it up to you. Enjoy our site, 
                    and when you're ready, give us a call! <br />
                    <strong>INFINITI Employment Solutions</strong>
                    </p>
                </div>

                </div>
            </Col>
            </Row>
        </Container>
        </section>
      {/* Section 4 ------------------------------------------------------------------ */}

    </div>
  );
};

export default AboutUs;